// extracted by mini-css-extract-plugin
module.exports = {"form":"CommentForm_form__VpWEG","submit":"CommentForm_submit__MpqTt","message":"CommentForm_message__rkvi2"};
module.exports.__checksum = "3ed8d9bb126d"
